import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENV_CONFIG } from '@digilize/shared/utils/tokens';
import { EnvConfig } from '@shared/definitions';
import { map, Observable } from 'rxjs';

import { ReservationUserData } from '../models/reservation';
import { CartDto } from './dto/products.dto';

export interface ReservationRequestBody {
  table_start: string; // ISO date format
  language?: string;
  full_name: string;
  phone: string;
  email: string;
  notes: string;
  restaurant_reservation_id: string;
  skip_availability_validation?: boolean;
}

export interface ReservationAvailabilityResponse {
  hours: string[];
  info: {
    html: string;
    from: string;
    to: string;
    day: string;
    is_full_day: boolean;
  };
  special: {
    html: string;
    from: string;
    to: string;
    day: string;
    is_full_day: boolean;
  };
}

@Injectable({
  providedIn: 'root',
})
export class ReservingService {
  private readonly baseUrl = `${this.config.api}/v2.0/restaurant-reservations`;

  constructor(@Inject(ENV_CONFIG) private readonly config: EnvConfig, private readonly client: HttpClient) {}

  makeReservation(dateString: string, userData: ReservationUserData, notes: string, restaurant_reservation_id: string) {
    const requestBody: ReservationRequestBody = {
      restaurant_reservation_id,
      table_start: dateString,
      full_name: userData.firstname + ' ' + userData.lastname,
      phone: userData.phoneNumber,
      email: userData.email,
      notes: notes,
      skip_availability_validation: true,
    };

    return this.client.put<CartDto>(`${this.baseUrl}`, requestBody);
  }

  makePartialReservation(date: Date, notes: string, restaurant_reservation_id: string) {
    const requestBody: Omit<ReservationRequestBody, 'phone' | 'email' | 'full_name'> = {
      restaurant_reservation_id,
      table_start: date.toISOString(),
      notes: notes,
      skip_availability_validation: true,
    };

    return this.client.put<CartDto>(`${this.baseUrl}`, requestBody);
  }

  getAvailability(restaurant_reservation_id: string): Observable<Date[]> {
    return this.client
      .post<ReservationAvailabilityResponse>(`${this.baseUrl}/availability`, {
        restaurant_reservation_id,
      })
      .pipe(map((response) => response.hours.map((hour) => new Date(hour))));
  }
}
